export default __webpack_public_path__ + "static/media/mental-health-line.bc510ec7.svg";